import clsx from 'clsx';
import * as prismicH from '@prismicio/helpers';

import { Bounded } from '../../components/Bounded';
import { BaseSlice } from '../../components/BaseSlice';
import { RichText } from '../../components/RichText';
import { PublicationItem } from '../List';

/**
 * @typedef {import("@prismicio/client").Content.PublicationSlice} PublicationSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<PublicationSlice>} PublicationProps
 * @param {PublicationProps}
 */
const Publication = ({ slice, index }) => {
  return (
    <Bounded as="section" index={index}>
      <BaseSlice>
        <div
          className={clsx(
            slice.primary?.center && 'text-center',
            prismicH.isFilled.richText(slice.primary?.text) && 'mb-5'
          )}>
          <RichText field={slice.primary?.text} />
        </div>
        <PublicationItem item={slice.primary.pub} />
      </BaseSlice>
    </Bounded>
  );
};

export default Publication;
